module.exports = __webpack_public_path__ + "static/media/9.0a13327a.jpeg";